import NavigationCategories from "components/Navigation/NavigationCategories"
import React, { Component } from "react"
import FilterContainer from "components/Filter/FilterContainer"
// import {Link, IndexLink} from 'react-router-dom'
import { Header } from "semantic-ui-react"
import shop from "shop/shop"
import app from "app.controller"
import { observer } from "mobx-react"
import categoryStore from "stores/categoryStore"
import "components/Navigation/NavigationSidebar.scss"
import productStore from "stores/productStore"

@observer
export default class NavigationSidebar extends Component {
	constructor(props) {
		super(props)
		this.state = {
			categoryData: []
		}
	}

	componentDidMount() {
		shop.events.loaded.add(this.onLoad)
	}

	onLoad = () => {
		this.setState({
			categoryData: shop.categories
		})
	}

	componentWillUnmount() {
		shop.events.loaded.remove(this.onLoad)
	}

	close = () => {
		app.sidebarLeft.close.dispatch()
	}

	render() {
		// const { hasFilter } = categoryStore
		const {showTitle = true} = this.props
		let categoryData         = categoryStore.categories
		const {currentCategory}  = productStore
		const {categoryId}       = currentCategory
		const category           = categoryStore.categoriesById.get(categoryId)
		const {hash} = categoryStore
		return (
			<nav className="nav NavigationSidebar nav-sidebar pb4 h-100 overflow-y-auto">
				<FilterContainer category={category} query={this.props.query}/>
				<div className=" limited-height NavigationMenuVertical">
				
					
					<NavigationCategories key={hash} categories={categoryData} />
				</div>
			</nav>
		)
	}
}



// WEBPACK FOOTER //
// ./src/theme/giraffiti/components/Navigation/NavigationSidebar.js